import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AppNavbar from './components/AppNavbar';
import Home from './components/Home';
import Error from './components/Error';
import ProjectAircraftwar from './components/ProjectAircraftwar';
import Project from './components/Project';
import Game from './components/Game';
import Maps from './components/Maps';
import Dashboard from './components/dashboard/Dashboard';
import Login from './components/dashboard/Login';
import Page1 from './components/dashboard/Page1';
import Page2 from './components/dashboard/Page2';
import CancerClassifier from './components/dashboard/CancerClassifier';
import PeopleDetection from './components/dashboard/PeopleDetection';
import PeopleSegmentation from './components/dashboard/PeopleSegmentation';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div>
          <AppNavbar />
          <div className="starter-template">
            <section id="main" className="col-lg-12">
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/aircraft-war" element={<ProjectAircraftwar />} />
                <Route path="/project/:id" element={<Project />} />
                <Route path="/project/:id/game" element={<Game />} />
                <Route path="/project/:id/maps" element={<Maps />} />
                <Route path="/projects/socialalerts" element={<Navigate to="/project/alertsapp" />} />
                <Route path="/projects/timerin" element={<Navigate to="/project/timerin" />} />
                <Route path="/projects/racktrack" element={<Navigate to="/project/racktrack" />} />
                <Route path="/maps" element={<Maps />} />
                <Route path="*" element={<Error />} />

                {/* Dashboard routes (protected) */}
                <Route path="/dashboard/login" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />}>
                  <Route index element={<Page1 />} />
                  <Route path="page1" element={<Page1 />} />
                  <Route path="page2" element={<Page2 />} />
                  <Route path="cancer-classifier" element={<CancerClassifier />} />
                  <Route path="people-detection" element={<PeopleDetection />} />
                  <Route path="people-segmentation" element={<PeopleSegmentation />} />
                </Route>
              </Routes>
            </section>
            <footer id="footer" className="col-lg-12">
              <hr />
              <p>Copyright &copy; CloudsApps {new Date().getFullYear()}</p>
            </footer>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
